import jquery from "jquery";
import translatorManager from 'ts-translate-js';

/**
 * @deprecated This syntax removes the "tr("" once compiled by typescript. Use this syntax instead : import TranslateManager from 'ts-translate-js'; const tr = TranslateManager.boundTR;
 */
export const tr = translatorManager.boundTR; 

/**
 * @deprecated This syntax removes the "tr("" once compiled by typescript. Use this syntax instead : import TranslateManager from 'ts-translate-js'; const tr = TranslateManager.boundTR;
 */
export const trN = tr;

export const $ = jquery;